import dateFormat from "dateformat";
import { ref, uploadBytesResumable, getDownloadURL, getStorage, listAll, getMetadata, deleteObject, getBlob, updateMetadata } from "firebase/storage";
import { app, getCompanyId, getCurrentUser, getCurrentUserUID, sendError } from "./firebase";

var commentId: string | null = "";
var clientId = "";
var lastFileList: any[] = [];

var lastPath: string = "";
var lastFileData: { url: string, metadata: any };
var loading = false;

const storage = getStorage(app);

function base64ToBlob(image: any) {

    // const mime = fileDate[0].match(/:(.*?);/)[1];
    const byteString = atob(image.base64String);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'image/' + image.format });
    return blob;
}

export function getUserIdFromPath(path: string) {
    const slices = path.split('_');
    var n = slices[slices.length - 1];
    return n.substring(0, n.indexOf("."));
  }

 export function getDateFromPath(path: string) {
    const slices = path.split('/');
    var n = slices[slices.length - 1];
    n = n.substring(0, 14);
    return n.substring(0, 4) + "-" + n.substring(4, 6) + "-" + n.substring(6, 8) + " " + n.substring(8, 10) + ":" + n.substring(10, 12);
  }

export async function getFileList(_clientId: string, _commentId: string | null, reload = false) {
    if (loading) {
        return null;
    }
    if (!reload && clientId === _clientId && commentId === _commentId) {
        return lastFileList;
    }
    loading = true;
    clientId = _clientId;
    commentId = _commentId;
    // Create a reference under which you want to list
    const listRef = ref(storage, "/companies/" + getCompanyId() + "/clients/" + clientId + "/comments/" + (commentId !== null ? commentId : ""));

    // Find all the prefixes and items.
    try {
        const res = await listAll(listRef);
        lastFileList = [];
        for (var i = 0; i < res.items.length; i++) {
            const item = res.items[i];
            const fileRef = ref(storage, item.fullPath);
            var add = true;// getCurrentUser().role === "manager";
            if(!add){
               add = getUserIdFromPath(item.fullPath) == getCurrentUser().id;
            } 
            
            var permissions = undefined;
            var permission = 'none';
            //if (!add) {
                permissions = await getMetadata(fileRef);
                //console.log("firebaseStorage-getFileList", permissions)
                if (permissions !== undefined && permissions.customMetadata !== undefined && permissions.customMetadata.permissions !== undefined) {
                    let p = JSON.parse(permissions.customMetadata.permissions);
                    permissions = p;
                    if(p[getCurrentUser().id] !== undefined && p[getCurrentUser().id] !== 'none'){
                        add = true;
                        permission = p[getCurrentUser().id];
                    }
                }else{
                    permissions = {};
                }
            //}
            if (add) {
                const url = await getDownloadURL(fileRef);
                lastFileList.push({ path: item.fullPath, url: url, permissions: permissions, permission: permission })
                //console.log({ path: item.fullPath, url: url, permissions: permissions, permission: permission });
                //lastFileList.push({ path: item.fullPath, url: url })
                //lastFileList.push({path:item.fullPath})
            }
        }
        loading = false;
        return lastFileList;
    } catch (error) {
        console.error("getFileList error: ", error);
    }
    loading = false;
    return lastFileList;
}

export async function getFileBlob(path: string) {
    const fileRef = ref(storage, path);
    try {
        const blob = await getBlob(fileRef);

        return lastFileData;
    } catch (error) {
        console.error("getFile error: ", error);
    }

}

export async function getFileMetadata(path: string) {
    try {
        const fileRef = ref(storage, path);
        return await getMetadata(fileRef);
    } catch (error) {
        console.error("getFileMetadata error: ", error);
    }
    return null;
}

export async function getFile(path: string) {
    if (lastPath === path) {
        return lastFileData;
    }
    for (var i = 0; i < lastFileList.length; i++) {
        if (lastFileList[i].path === path) {
            return lastFileList[i];
        }
    }
    lastPath = path;
    const fileRef = ref(storage, path);
    try {
        const metadata = await getMetadata(fileRef);
        const url = await getDownloadURL(fileRef);
        lastFileData = { url: url, metadata: metadata };
        return lastFileData;
    } catch (error) {
        console.error("getFile error: ", error);
    }
    return undefined;
}


export async function uploadFile(clientId: string, commentId: string | null, image: any) {
    const fileName = dateFormat(new Date(), "yyyymmddHHMMss") + "_" + getCurrentUserUID() + "." + image.format;
    //console.log(image);
    const storageRef = ref(storage, "/companies/" + getCompanyId() + "/clients/" + clientId + "/comments/" + (commentId !== null ? commentId + "/" : "") + fileName);

    // progress can be paused and resumed. It also exposes progress updates.
    // Receives the storage reference and the file to upload.
    const metadata = {
        contentType: 'image/' + image.format,
        customMetadata: {
            'userId': getCurrentUserUID() + "",
        }
    };
    try {
        const uploadTask = await uploadBytesResumable(storageRef, base64ToBlob(image), metadata);
        //const uploadTask = await uploadBytesResumable(storageRef, base64ToBlob(image), metadata);
        //const uploadTask = await uploadBytesResumable(storageRef, image, metadata);
    } catch (error) {
        console.log(error);
    }

    return;
}

export async function updateFileMetadata(path: string, metadata: any) {
    //console.log("firebaseStorage-saveMetadata", path, metadata);
    try {
        const storageRef = ref(storage, path);
        await updateMetadata(storageRef, { customMetadata: metadata });
        sendError("Zapisano uprawnienia!");
    } catch (error) {
        console.log(error);
    }
}

export async function updateFile(path: string, image: Blob) {
    const storageRef = ref(storage, path);
    const metadata = {
        contentType: image.type,
        customMetadata: {
            'userId': getCurrentUserUID() + "",
        }
    };
    try {
        const uploadTask = await uploadBytesResumable(storageRef, image, metadata);
        const url = await getDownloadURL(storageRef);
        for (var i = 0; i < lastFileList.length; i++) {
            if (lastFileList[i].path === path) {
                lastFileList[i].url = url;
                break;
            }
        }
    } catch (error) {
        console.log(error);
    }
    return;
}

export async function removeFile(path: string) {
    const fileRef = ref(storage, path);
    try {
        await deleteObject(fileRef);
        return true;
    } catch (error) {
        console.log(error);
    }
    return false;
}